<template>
  <div class="toast-container top-right">
    <transition-group name="toast" tag="div">
      <toast-item
        v-for="toast in toasts"
        :key="toast.id"
        :id="toast.id"
        :type="toast.type"
        :message="toast.message"
        :actions="toast.actions"
        @remove="removeToast"
      />
    </transition-group>
  </div>
</template>

<script>
import ToastItem from './ToastItem.vue'
import { EventBus } from '@/services/eventBus'
export default {
  name: 'ToasterContainer',
  components: {
    ToastItem
  },
  data() {
    return {
      toasts: [],
      nextId: 1
    }
  },
  created() {
    EventBus.$on('show-toast', (type, message, options) => {
      this.addToast(type, message, options)
    })
    EventBus.$on('remove-toast', (id) => {
      this.removeToast(id)
    })
  },
  beforeDestroy() {
    EventBus.$off('show-toast')
    EventBus.$off('remove-toast')
  },
  methods: {
    addToast(type, message, options = {}) {
      const toast = {
        id: this.nextId++,
        type,
        message,
        options: { ...this.getDefaultOptions(), ...options },
        timestamp: Date.now()
      }
      
      this.toasts.push(toast)
      
      // Auto remove if duration is not null
      if (toast.options.duration !== null) {
        setTimeout(() => {
          this.removeToast(toast.id)
        }, toast.options.duration)
      }
      
      return toast
    },
    
    removeToast(id) {
      const index = this.toasts.findIndex(toast => toast.id === id)
      if (index > -1) {
        this.toasts.splice(index, 1)
      }
    },
    
    getDefaultOptions() {
      return {
        duration: 5000
      }
    },
    
    // Public API methods for compatibility
    success(message, options = {}) {
      return this.addToast('success', message, options)
    },
    
    error(message, options = {}) {
      return this.addToast('error', message, options)
    },
    
    info(message, options = {}) {
      return this.addToast('info', message, options)
    }
  }
}
</script>

<style scoped>
.toast-container.top-right {
  position: fixed;
  top: 0;
  right: 60px;
  z-index: 10000;
  pointer-events: none;
}

/* Toast transition animations */
.toast-enter-active, .toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter {
  transform: translateX(100%);
  opacity: 0;
}

.toast-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.toast-move {
  transition: transform 0.3s ease;
}

@media screen and (max-width: 1289px) {
  .toast-container.top-right {
    right: 30px;
  }
}
</style> 